<template>
  <div v-on:mouseover="showOptions = true"
       v-on:mouseleave="showOptions = false" class="mt-5 card">
    <i v-if="showOptions" class="fa fa-window-close" v-on:click="remove" aria-hidden="true"></i>
    <img v-on:error="imgError(this)"
         class="card-img-top"
         v-bind:src="image"
         max-height="150px"
         alt="Card image cap">
    <span v-if="showOptions" class="dropdown-wrapper">
      <b-dropdown text="Options" class="m-sm-2">
        <b-dropdown-item v-on:click="setProfileImage">Make Profile Image</b-dropdown-item>
        <b-dropdown-item v-if="getUserType === 'business'" v-on:click="setBannerImage">Make Banner Image</b-dropdown-item>
        <b-dropdown-item v-on:click="remove">Delete</b-dropdown-item>
      </b-dropdown>
    </span>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'

export default {
  created () {
    this.image = this.imageUrl
  },
  props: {
    imageUrl: String
  },
  data () {
    return {
      showOptions: false,
      image: null
    }
  },
  methods: {
    ...mapActions('business', [
      'syncData'
    ]),
    ...mapMutations('business', [
      'updateProfileImage',
      'updateBannerImage'
    ]),
    imgError () {
      var that = this
      setTimeout(function () {
        that.image += '?' + new Date().getTime()
      }, 500)
    },
    async remove () {
      var image = this.imageUrl.split('/').pop()
      if (this.getUserType === 'business') await this.$store.commit('business/removeImage', image)
      if (this.getUserType === 'user') await this.$store.commit('user/removeImage', image)
      await this.syncData()
    },
    async setProfileImage () {
      var image = this.imageUrl.split('/').pop()
      if (this.getUserType === 'business') await this.$store.commit('business/updateProfileImage', image)
      if (this.getUserType === 'user') await this.$store.commit('user/updateProfileImage', image)
      await this.syncData()
    },
    async setBannerImage () {
      var image = this.imageUrl.split('/').pop()
      this.updateBannerImage(image)
      await this.syncData()
    }
  },
  computed: {
    ...mapGetters('user', [
      'getUserType'
    ])
  }
}
</script>

<style scoped>
.card {
  margin: 1rem !important;
}

.fa-window-close {
  position: absolute;
  top: .3rem;
  right: .3rem;
  font-size: 30px;
  cursor: pointer;
  color: black;
}

.dropdown-wrapper {
  position: absolute;
  z-index: 3;
  top: 0rem;
  left: 0rem;
}

.dropdown-wrapper >>> .btn {
  background-color: black !important;
}

</style>



// WEBPACK FOOTER //
// src/components/profile/shared/pictures/ImageCard.vue